<template>
    <div class="advanced_picture_edit" :style="{'margin-top':topHeight+'px'}">
        <img src="./img/advEdit/select_top.png" class="sel_img_ic" alt="">
        <div class="edit_top">
            <div class="edit_top_title">
                高级编辑
            </div>
            <div class="edit_top_right">
                <div class="edit_version" @click="version_select_show = !version_select_show">
                    版本选择：<span class="selc_name">{{version == 1 ? 'G2.5版' : 'G3.0版'}}</span>
                    <img src="./img/advEdit/select_down.png" class="select_down_ic" alt="">
                    <div class="edit_version_box" v-if="version_select_show">
                        <div :class="{'version_item': version, 'version_item_active': version == 1}" @click="changeVersion(1)">
                            <div class="vers_top">
                                G2.5版
                                <img class="select_ic" v-if="version == 1" src="./img/advEdit/select_Ic.png" alt="">
                            </div>
                            <div class="vers_bottom">
                                <div class="ver_tip">英文优秀</div>
                                <div class="ver_scor">5积分/次</div>
                            </div>
                        </div>
                        <div :class="{'version_item': version, 'version_item_active': version == 2}" @click="changeVersion(2)">
                            <div class="vers_top">
                                G3.0版
                                <img class="select_ic" v-if="version == 2" src="./img/advEdit/select_Ic.png" alt="">
                            </div>
                            <div class="vers_bottom">
                                <div class="ver_tip">更懂中文</div>
                                <div class="ver_scor">6积分/次</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="edit_video" @click="playVideo">视频演示</div>
            </div>
        </div>
        <div class="edit_bottom">
            <div class="edit_input_box">
                <textarea :placeholder="(item.pic_num==1||!item.pic_num)?'请输入修改上方图片的高级编辑描述，多个要求请用“，”隔开':'请针对上方图一、图二、图三、图四输入高级图片修改编辑命令，多个命令用“，”隔开'" v-model="inputText" class="edit_input"></textarea>
                <div class="edit_btn_box">
                    <div class="edit_btn" @click="editClick">开始编辑</div>
                </div>
            </div>
        </div>
        <div class="video_cover" v-show="videoShow">
            <div class="video_panel">
                <div class="videoBox">
                    <video ref="videoref" controls src="https://jindouyuan202105.oss-cn-beijing.aliyuncs.com/ad/ad_mj_edit.mp4"></video>
                    <div class="close_btn" @click.stop="closePlay">
                    <img class="closeTuiImg" src="./img/img_icon_10.png"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import utils from '@/utils/index.js'
    export default {
        props: {
            item: {
                type: Object,
                default: () => {}
            },
            soft_type: {
                type: String,
                default: 'mj'
            },
            //距离顶部的距离
            topHeight: {
                type: Number,
                default: -5
            },
            /* 按钮opt类型 */
            btn_opt_type: {
                type: String,
                default: 'btn_mj_create'
            },
        },
        data(){
            return{
                inputText: '',
                version: 1,
                version_select_show: false,
                videoShow: false,
            }
        },
        computed: {
            isLogin() {
                return this.$store.state.isLogin;
            },
            userInfo(){
                return this.$store.state.userInfo
            }
        },
        methods: {
            closePlay() {
                this.$refs.videoref.pause();
                this.videoShow = false;
            },
            playVideo(){
                this.videoShow = true;
                this.$refs.videoref.play();
            },
            changeVersion(index){
                this.version = index;
            },
            checkLogin() {
                // 检查登录状态
                if (!this.isLogin) {
                    this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
                    confirmButtonText: '立即登录',
                    cancelButtonText: '关闭',
                    type: 'warning',
                    customClass: 'confirm_box'
                    }).then(() => {
                    this.$store.commit('setUserInfo', null)
                    this.$store.commit('setIsLogin', false)
                    this.$store.commit('setShowLogin', true)
                    }).catch(() => {
                    });
                    return false;
                } else {
                    return true;
                }
            },
            editClick(){
                this.checkLogin()
                if(!this.checkLogin()) return
                if(!utils.setOptData(this.userInfo,this.btn_opt_type)){
                    return
                }
                if(!this.inputText.trim().length){
                    this.$message({
                        message: '请输入编辑描述!',
                        type: 'waring'
                    });
                    return;
                }
                let formData = {
                    data: {model_version: this.version==1 ? 'v2.5' : 'v3.0'},
                    iw_url: this.item.img_url,
                    prompt: this.inputText,
                    parent_draw_id: this.item.draw_id,
                    soft: this.soft_type,
                    pic_num: this.item.pic_num
                }
                this.$http.post('/front/aimj/edit/', formData).then(res => {
                    if(res.status == 200){
                        this.$emit('editSuccess',res.data.draw);
                    }
                    
                })
            }
        },
    }
</script>

<style lang="scss" scoped>
.advanced_picture_edit{
    // width: 200px;
    width: 100%;
    // height: 200px;
    box-sizing: border-box;
    border-radius: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    background: #fff;
    position: relative;
    .sel_img_ic{
        position: absolute;
        top: -8px;
        left: 50%;
        transform: translateX(-50%);
        width: 10px;
        height: 10px;
    }
    // background: linear-gradient(to bottom,
    //  rgba(255, 255, 255, 0),
    //   rgba(255, 255, 255, 0.2) 10%,
    //   rgba(255, 255, 255, 0.8) 24%,
    //   rgba(255, 255, 255, 0.95) 80%,
    //   rgba(255, 255, 255, 0.99) 90%,
    //    #fff), no-repeat;
    // margin-top: -50px;
    // position: relative;
    // z-index: 100;
    padding: 10px;
    .edit_top{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        // padding: 10px 15px;
        box-sizing: border-box;
        // padding-top: 10px;
        
        .edit_top_title{
            font-size: 14px;
            font-weight: 600;
            color: #000;
        }
        .edit_top_right{
            display: flex;
            align-items: center;
            font-size: 12px;
            color: #666;
            .edit_version{
                position: relative;
                display: flex;
                align-items: center;
                border: 1px solid #f49f0b;
                border-radius: 5px;
                box-sizing: border-box;
                padding: 2px 5px;
                color: #f49f0b;
                background: #fef9c3;
                // .selc_name{ 
                // }
                .select_down_ic{
                    width: 8px;
                    height: 8px;
                    margin-left: 5px;
                }
                .edit_version_box{
                    position: absolute;
                    top: 25px;
                    right: 0;
                    // width: 130px;
                    width: 100%;
                    height: 100px;
                    background: #fef9c3;
                    // border-radius: 5px;
                    border-bottom-left-radius: 5px;
                    border-bottom-right-radius: 5px;
                    padding: 5px;
                    border: 1px solid #f49f0b;
                    border-top: none;
                    .version_item{
                        border-bottom: 1px dashed #ccc;
                        padding-bottom: 5px;
                        .vers_top{
                            font-size: 12px;
                            color: #000;
                            display: flex;
                            align-items: center;
                            .select_ic{
                                width: 12px;
                                height: 12px;
                                margin-left: 5px;
                            }
                        }
                        .vers_bottom{
                            font-size: 10px;
                            color: #666;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                        }
                    }
                    .version_item_active{
                        .vers_top{
                            color: #f49f0b;
                        }
                    }
                    .version_item:last-child{
                        border-bottom: none;
                        .vers_top{
                            margin-top: 5px;
                        }
                    }

                }
            }
            .edit_video{
                border: 1px solid #ccc;
                padding: 1px 6px;
                border-radius: 3px;
                // font-size: 10px;
                margin-left: 10px;
            }
        }
    }
    .edit_bottom{
        // border-top: 1px dashed #ccc;
        margin-top: 10px;
        .edit_input_box{
            border: 1px solid #ccc;
            border-radius: 5px;
            margin-top: 10px;
            min-height: 80px;
            overflow: hidden;
            padding: 5px;
            .edit_input{
                width: 100%;
                min-height: 50px;
                border: none;
                outline: none;
                padding: 5px;
                box-sizing: border-box;
                font-size: 12px;
                color: #000;
            }
            .edit_btn_box{
                display: flex;
                justify-content: flex-end;
                .edit_btn{
                    width: 80px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 28px;
                    font-size: 12px;
                    color: #fff;
                    background: linear-gradient(to right, #fb9595, #7681f6);
                    border-radius: 5px;
                    margin-top: 5px;
                }
            }

        }
    }
    .video_cover{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
        .video_panel {
            width: calc(100% - 80px);
            height: auto;
            border:5px solid #ffffff;

            .videoBox {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;

            video {
                width: 100%;
                height: auto;
            }

            .close_btn {
                position: absolute;
                bottom: -40px;
                left: 50%;
                transform: translate(-50%);
                width: 26px;
                height: 26px;
                cursor: pointer;
                border-radius: 50%;
                background: #ffffff;
                display: flex;
                justify-content: center;
                align-items: center;

                .closeTuiImg {
                width: 15px;
                height: 15px;
                }
            }
            }
        }
    }
}

</style>